import axios from "../axiosInstance";
import { DeleteResourceShareResponse } from "./types";

export const deleteResourceShare = async (
  shareUuid: string,
): Promise<DeleteResourceShareResponse> => {
  const response = await axios.delete<DeleteResourceShareResponse>(
    `/api/private/resource-shares/${shareUuid}`,
  );
  return response.data;
};
